import { FormikProvider, useFormik } from "formik";
import { useState } from "react";
import styled from "styled-components";
import Button from "../Button/Button";
import ResultsTable from "./ResultsTable";
import { getLineItemReports, LineItemReport } from "./manageReports";
import config from "../../config";
import DateTimeField from "../FormFields/DateTimeField";
import { unixToMS } from "../../utils/timeUtilities";

const LoadingSpinner = styled.img`
	width: 100px;
`;

const spinnerSrc = config.assets.loading.primary;

const LineItem = () => {
	const [lineItemReports, setLineItemReports] = useState<LineItemReport[]>();
	const [lineItemReportLoading, setLineItemReportLoading] = useState(false);

	const formikProps = useFormik({
		initialValues: {
			startDateTime: undefined as number | undefined,
			endDateTime: undefined as number | undefined,
		},
		enableReinitialize: false,
		onSubmit: async () => {},
		validateOnBlur: false,
	});

	const generateInformation = async () => {
		setLineItemReportLoading(true);
		try {
			const start = formikProps.values.startDateTime;
			const end = formikProps.values.endDateTime;

			if (start !== undefined && end !== undefined) {
				const reports = await getLineItemReports(unixToMS(start), unixToMS(end));
				setLineItemReports(reports);
			}
		} catch (error) {
			console.error("Failed to get line item report: ", error);
		}
		setLineItemReportLoading(false);
	};

	return (
		<div>
			<FormikProvider value={formikProps}>
				<div className="flex items-center space-x-4 pb-5">
					<div className="flex gap-[1rem] items-center">
						<DateTimeField
							name="startDateTime"
							placeholder="Start Date Time"
							value={formikProps.values.startDateTime}
						/>
						<DateTimeField
							name="endDateTime"
							placeholder="End Date Time"
							value={formikProps.values.endDateTime}
						/>
					</div>
					<Button onClick={generateInformation}>Generate</Button>
				</div>

				{lineItemReportLoading ? (
					<div className="pt-10 flex flex-col items-center justify-center">
						<div>Running Line Item Report...</div>
						<LoadingSpinner src={spinnerSrc} />
					</div>
				) : lineItemReports && lineItemReports.length > 0 ? (
					<ResultsTable data={lineItemReports} />
				) : null}
			</FormikProvider>
		</div>
	);
};

export default LineItem;
